import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NoTemplatesIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "216",
    height: "180",
    viewBox: "0 0 216 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_dd_7492_102459)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M190 55.9999L110.103 34.8442C107.623 33.9142 104.116 34.6333 102.664 36.0878L21.8488 117.337C21.3916 117.796 20.684 118.037 20.5898 118.828C20.3965 120.452 22.6013 123.807 24.2088 124.238L108.622 146.856C110.605 147.387 113.391 146.639 114.843 145.185L195.037 64.4762C197.188 61.6914 191.984 56.5315 190 55.9999Z",
        fill: "url(#paint0_linear_7492_102459)"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M189.48 55.8666L109.537 34.4461C106.336 33.5885 101.842 34.7927 99.4991 37.1358L21.7073 114.928C19.3641 117.271 20.0594 119.866 23.2602 120.723L101.271 141.626C105.538 142.77 111.531 141.164 114.655 138.04L191.032 61.6621C193.376 59.319 192.68 56.7242 189.48 55.8666Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter1_f_7492_102459)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M115.276 139.583L191.475 62.0083C193.66 59.7838 193.129 57.3272 190.256 56.3697L186.985 55.2793L110.139 35.0347C106.942 34.1925 102.475 35.3936 100.137 37.7239L22.1056 115.501C19.7753 117.824 20.43 120.402 23.5738 121.284L101.732 143.2C106.028 144.405 112.145 142.771 115.276 139.583Z",
        fill: "url(#paint1_linear_7492_102459)"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M189.48 55.8666L109.537 34.4461C106.336 33.5885 101.842 34.7927 99.4991 37.1358L21.7073 114.928C19.3641 117.271 20.0594 119.866 23.2602 120.723L101.271 141.626C105.538 142.77 111.531 141.164 114.655 138.04L191.032 61.6621C193.376 59.319 192.68 56.7242 189.48 55.8666Z",
      fill: "url(#paint2_linear_7492_102459)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M62.9919 83.656C63.811 82.915 65.3375 82.5554 66.4012 82.8528L116.83 96.9506C117.893 97.248 118.092 98.0898 117.273 98.8308L116.564 99.4713C115.745 100.212 114.219 100.572 113.155 100.275L62.7266 86.1767C61.6629 85.8793 61.4646 85.0375 62.2837 84.2966L62.9919 83.656Z",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M56.5607 89.4728C57.3799 88.7318 58.9063 88.3722 59.9701 88.6696L95.4862 98.5985C96.55 98.8959 96.7483 99.7377 95.9291 100.479L95.221 101.119C94.4018 101.86 92.8754 102.22 91.8116 101.922L56.2955 91.9935C55.2317 91.6961 55.0334 90.8543 55.8526 90.1133L56.5607 89.4728Z",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M50.1305 95.2895C50.9497 94.5486 52.4761 94.189 53.5399 94.4864L95.0209 106.083C96.0847 106.38 96.283 107.222 95.4638 107.963L94.7557 108.604C93.9365 109.345 92.4101 109.704 91.3463 109.407L49.8653 97.8102C48.8015 97.5128 48.6032 96.6711 49.4224 95.9301L50.1305 95.2895Z",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("rect", {
      width: "44.594",
      height: "2.47745",
      rx: "1",
      transform: "matrix(0.963074 0.269238 -0.741612 0.670829 81.0107 67.3568)",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("rect", {
      width: "49.5489",
      height: "2.47745",
      rx: "1",
      transform: "matrix(0.963074 0.269238 -0.741612 0.670829 76.4175 71.5117)",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter2_d_7492_102459)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M157.891 47.1508C154.021 51.0208 146.556 53.1789 141.218 51.971C138.943 51.4562 137.421 50.413 136.724 49.0857C134.649 45.3695 136.339 44.9972 138.56 42.7767C142.43 38.9066 149.895 36.7486 155.233 37.9564C157.44 38.456 158.645 37.9856 159.663 40.7243C160.353 42.5824 160.16 44.8813 157.891 47.1508Z",
        fill: "url(#paint3_linear_7492_102459)"
      })
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9.90979",
      cy: "9.90979",
      r: "9.90979",
      transform: "matrix(0.975342 0.220697 -0.707107 0.707107 144.948 34.5306)",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M140.454 58.7812C140.251 58.3544 139.559 58.1882 138.912 58.0277L63.9879 39.4223C63.0084 39.1599 61.3849 39.7508 60.0865 40.7839C59.6326 41.1451 59.1983 41.5173 58.6895 41.8511L53.4872 45.2635C51.9389 46.5022 53.017 49.0428 54.1633 49.3499L130.473 69.797C131.62 70.1043 133.647 69.2425 135.004 67.8712L139.917 62.9074C140.942 61.8717 140.916 59.7551 140.454 58.7812Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M139.678 58.0114L63.3684 37.5643C62.2222 37.2572 60.1938 38.1188 58.8368 39.4901L53.9245 44.4539C52.5675 45.8251 52.3975 47.1848 53.5438 47.4919L129.853 67.939C131 68.2463 133.028 67.3845 134.385 66.0132L139.297 61.0494C140.654 59.6781 140.825 58.3186 139.678 58.0114Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M69.2546 41.5687L69.2546 41.5687C67.4017 40.9608 64.5652 41.5885 62.9189 42.9707C61.6346 44.0491 61.4205 45.31 62.3876 46.0999C62.693 46.3554 63.1053 46.5515 63.5992 46.6762L63.5992 46.6762C64.3958 46.8645 65.3618 46.8595 66.348 46.662C66.5954 46.6128 66.792 46.4574 66.7874 46.3148C66.7837 46.1718 66.5799 46.0952 66.332 46.1436C66.3302 46.144 66.3284 46.1443 66.3266 46.1447C64.344 46.5342 62.7108 45.923 62.6786 44.7795C62.6464 43.636 64.2275 42.3932 66.2101 42.0037C67.104 41.8281 67.9712 41.8511 68.6419 42.0684C70.0225 42.5498 70.2147 43.739 69.087 44.822L68.907 44.9985L68.907 44.9985C68.6554 45.2433 68.1749 45.3752 67.8339 45.2931C67.8265 45.2913 67.8192 45.2895 67.812 45.2875C67.4953 45.1791 67.4562 44.9053 67.7224 44.6606L68.8656 43.5389C69.0118 43.3955 68.968 43.2409 68.7678 43.1936C68.5859 43.1492 68.3315 43.2094 68.1752 43.3338C68.0698 43.0265 67.7524 42.7947 67.2883 42.6861C66.2639 42.4508 64.8365 42.8532 64.1002 43.5849C63.3639 44.3166 63.5975 45.1005 64.6219 45.3358C65.2094 45.4707 65.9623 45.3989 66.6514 45.1421C66.6007 45.6681 67.2818 45.9833 68.1726 45.846C68.2825 45.8291 68.3927 45.8056 68.5015 45.7759C68.9567 45.6563 69.3664 45.4366 69.6319 45.1698L69.8119 44.9933L69.8119 44.9933C71.2058 43.646 70.9657 42.1703 69.2546 41.5687L69.2546 41.5687ZM65.1305 44.8117C64.512 44.6656 64.3767 44.1879 64.8283 43.7447C65.28 43.3016 66.1475 43.0609 66.766 43.2071C67.3846 43.3532 67.5198 43.8309 67.0682 44.2741C66.6152 44.7161 65.7497 44.9563 65.1305 44.8117Z",
      fill: "#FCFCFD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M133.728 59.5176L76.9139 44.2943C76.0605 44.0656 74.863 44.3912 74.2387 45.0221L71.9787 47.3058C71.3544 47.9366 71.5405 48.633 72.3939 48.8616L129.208 64.085C130.062 64.3137 131.259 63.988 131.883 63.3572L134.143 61.0735C134.768 60.4426 134.582 59.7464 133.728 59.5176Z",
      fill: "#FCFCFD"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_dd_7492_102459",
        x: "0.578125",
        y: "4.42749",
        width: "214.97",
        height: "170.599",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "-10"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7492_102459"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "8"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_7492_102459",
          result: "effect2_dropShadow_7492_102459"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow_7492_102459",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_f_7492_102459",
        x: "19.71",
        y: "33.7657",
        width: "174.109",
        height: "110.831",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "0.5",
          result: "effect1_foregroundBlur_7492_102459"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter2_d_7492_102459",
        x: "115.783",
        y: "21.6211",
        width: "64.2324",
        height: "54.6852",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.411765 0 0 0 0 0.258824 0 0 0 0 0.972549 0 0 0 0.12 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7492_102459"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_7492_102459",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_7492_102459",
        x1: "196.871",
        y1: "54.673",
        x2: "11.813",
        y2: "9.5415",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#8B98DE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.200284",
          stopColor: "#C1CBFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.303741",
          stopColor: "#E9ECFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.310958",
          stopColor: "#DDE2FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.333069",
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.491969",
          stopColor: "#CED6FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.857402",
          stopColor: "#94A0E3"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#DAE0FF"
        })]
      }), /*#__PURE__*/_jsx("linearGradient", {
        id: "paint1_linear_7492_102459",
        x1: "195.966",
        y1: "50.0149",
        x2: "-156.015",
        y2: "505.621",
        gradientUnits: "userSpaceOnUse",
        children: /*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        })
      }), /*#__PURE__*/_jsx("linearGradient", {
        id: "paint2_linear_7492_102459",
        x1: "195.347",
        y1: "49.3953",
        x2: "-156.635",
        y2: "505.002",
        gradientUnits: "userSpaceOnUse",
        children: /*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        })
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_7492_102459",
        x1: "165.418",
        y1: "39.7426",
        x2: "154.942",
        y2: "26.8325",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.325361",
          stopColor: "#FCFCFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#E7EAF8"
        })]
      })]
    })]
  });
}